const AnimationSettings = {
    transition: {duration: 1.0},
    initial: {opacity: 0, y: -40},
    animate: {opacity: 1, y: 2},
    exit: {opacity: 0, y: -20}
};

export default AnimationSettings;
